import { render, staticRenderFns } from "./UiComponentList.vue?vue&type=template&id=a41dabdc&scoped=true&"
import script from "./UiComponentList.vue?vue&type=script&lang=js&"
export * from "./UiComponentList.vue?vue&type=script&lang=js&"
import style0 from "./UiComponentList.vue?vue&type=style&index=0&id=a41dabdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41dabdc",
  null
  
)

export default component.exports